import Vue from 'vue';

import i18n from '@/locales';
import axios from 'axios';
import VueAxios from 'vue-axios';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.request.use((config) => {
    config.headers = {...config.headers, 'Accept-Language': i18n.locale};
    const company = sessionStorage.getItem('company_id');
    if (company && !['/login', '/company/get'].includes(config.url || '')) {
        config.headers = {...config.headers, 'X-Company-Id': company};
    }
    return config;
});

export function changeCompany(id: number | string): void {
    if (id === 'platform') sessionStorage.removeItem('company_id');
    else sessionStorage.setItem('company_id', String(id));
    sessionStorage.removeItem('salon_id');
    sessionStorage.removeItem('userData');
    window.location.replace('/#/studios/index/0');
    window.location.reload();
}

Vue.use(VueAxios, axios);

export default {
    root: process.env.VUE_APP_API_URL,
    fileRoot: process.env.VUE_FILE_API_URL
};
